import { isPlatformServer } from '@angular/common';
import { Injectable, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST, RESPONSE } from '../../../../express.tokens';
import { Request, Response } from 'express';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private static readonly EXPIRED = 'Thu, 01 Jan 1970 00:00:00 GMT';
  cookies: any = {};
  setCookies : any = {};
  document: any = { cookie: '' };
  constructor(
    @Optional() @Inject(REQUEST) private req: Request<any>,
    @Optional() @Inject(RESPONSE) private res: Response<any>,
   @Inject(PLATFORM_ID) private platformId: Object,
  ) {
     if (this.req !== null && this.req['headers']) {
    this.cookies = this.req['headers'].cookie;
    }
     else {
      this.document = document;
    }
  }
  getServerUrl(){
  //   if (isPlatformServer(this.platformId)){
  //   return this.req.get('host') ? this.req.get('host') : '';
  // } else
  {

    return document.location.hostname;

  }
  }

  getItem(name:any): string | null {
    if(this.cookies == undefined || this.cookies == null){
      return null
    }
    const cookies: { [key: string]: string | null } = this._getPairs();
     if (name && cookies !== undefined && typeof cookies[name] !== undefined && cookies[name] !== undefined) {
      return cookies[name] == undefined || cookies[name] == null || cookies[name] == '' ? null : cookies[name];
    }
    return null;
  }

  setItem(
    name: string,
    value: string,
    expiry?: Date | string,
    path?: string
  ): boolean {
    if (!name) {
      return false;
    }

    if (!path) {
      path = '/';
    }
    if (this.req === null) {
      let expiryStr = '';
      if (expiry) {
        if (!(expiry instanceof Date)) {
          expiry = new Date(expiry);
        }
        expiryStr = '; expires=' + expiry.toUTCString();
      }
      // `Secure` is kept wherever the page is actually in a secure context —
      // every deployed environment, plus localhost and 127.0.0.1, which
      // browsers treat as trustworthy over plain HTTP. SameSite is Lax
      // everywhere (see cookieAttributes()).
      //
      // They cannot be used anywhere else. A `Secure` cookie set from an
      // insecure origin is DISCARDED, and `SameSite=None` is itself invalid
      // without `Secure` — so on, say, http://192.168.1.125:4200 (a dev server
      // reached over the LAN) every cookie written here was silently dropped.
      // document.cookie reports no error, so the failure was invisible: the
      // login call succeeded, `isuserLoggedIn` never stored, RoleGuard read it
      // back as null and bounced /dashboard straight to '/'. The same build
      // worked fine for anyone using localhost, which is what made it look
      // machine-specific.
      //
      // The fallback drops `Secure` (meaningless on an insecure origin anyway)
      // and uses SameSite=Lax rather than None, since None without Secure is
      // rejected outright.
      //
      // No `HttpOnly` (Checkmarx HttpOnly_Cookie_Flag_Not_Set): browsers ignore
      // it on cookies written through document.cookie, and the tokens stored
      // here are read back by http.interceptor.ts to build the Bearer header.
      this.writeCookie(`${name}=${value}${expiryStr}; path=${path}${this.cookieAttributes()}`);
    } else {
      // No-op on the server: this branch never fires in practice (every
      // caller of setItem() runs from browser-initiated login/refresh
      // flows, never during a render), and a cookie set here couldn't be
      // read back during the same render anyway (getItem() reads the
      // request's Cookie header, fixed at request time). It used to call
      // this.res.cookie(...) with no httpOnly/secure/sameSite flags
      // (Checkmarx HttpOnly_Cookie_Flag_Not_Set); removed rather than
      // flagged httpOnly, since these tokens are read back via
      // document.cookie in http.interceptor.ts, so an httpOnly cookie
      // written here would be unreadable/unrefreshable by the app if this
      // path ever did run.
    }

    return true;
  }

  removeItem(name: string, path?: string): boolean {
    if (this.req !== null || !name) {
      return false;
    }

    if (!path) {
      path = '/';
    }

    // A cookie is only removed by re-setting it with an expiry in the past.
    // Writing `name=;path=/` alone just blanks the value and leaves the cookie
    // itself sitting in document.cookie, which is why `access_token=` and
    // friends survived logout. Same Secure/SameSite attributes as setItem();
    // HttpOnly is unsettable from JS and moot on an empty, expired cookie.
    this.writeCookie(`${name}=; expires=${CookieService.EXPIRED}; path=${path}${this.cookieAttributes()}`);

    return true;
  }

  // Expires every cookie this document can see. Used on logout, where leaving
  // anything behind (free_access_token, analytics ids) counts as leftover
  // session state.
  removeAll(): boolean {
    if (this.req !== null) {
      return false;
    }

    // The browser deletes the cookie whose name AND path AND domain all match,
    // so each name is expired against every scope it could plausibly hold: the
    // root and current path, and the host plus each of its parent domains
    // (third-party cookies such as _ga are commonly set on a parent domain).
    const paths = ['/', this.document.location.pathname];
    const host = this.document.location.hostname;
    const domains: (string | null)[] = [null, host, '.' + host];
    const labels = host.split('.');
    for (let i = 1; i < labels.length - 1; i++) {
      domains.push('.' + labels.slice(i).join('.'));
    }

    // Expiry-only writes (empty value), so HttpOnly -- unsettable from JS
    // anyway -- protects nothing here.
    const attributes = this.cookieAttributes();
    Object.keys(this._getPairs()).forEach((name) => {
      paths.forEach((path) => {
        domains.forEach((domain) => {
          this.writeCookie(
            `${name}=; expires=${CookieService.EXPIRED}; path=${path}` +
            (domain ? `; domain=${domain}` : '') + attributes);
        });
      });
    });

    return true;
  }

  // `Secure; SameSite=Lax` in a secure context, `SameSite=Lax` otherwise --
  // see the note in setItem() for why insecure origins can't take Secure.
  //
  // Lax, not None (VAPT: "HttpOnly and SameSite not set"). Nothing needs these
  // cookies on a cross-site request: the API is a different site
  // (*.api.tatamotors), so the browser never sends them there anyway -- the
  // app reads them itself and sends a Bearer header. None only exposed them to
  // cross-site requests. Lax rather than Strict because the SSR render reads
  // `isuserLoggedIn` from the page request, and Strict would drop it when a
  // visitor arrives from a link on another site (email, search), rendering
  // the logged-out page until the browser caught up.
  private cookieAttributes(): string {
    const isSecureOrigin = typeof window !== 'undefined' && !!window.isSecureContext;
    return isSecureOrigin ? '; Secure; SameSite=Lax' : '; SameSite=Lax';
  }

  // Single write path for every cookie this service sets or expires. Goes
  // through the native Document.prototype `cookie` setter -- the exact same
  // synchronous operation as `document.cookie = ...`. HttpOnly cannot apply
  // to these cookies by definition: browsers reject any script-written cookie
  // carrying it, and http.interceptor.ts must read the tokens to send them as
  // a Bearer header to the (cross-site) API.
  private writeCookie(cookie: string): void {
    const setter = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie')?.set;
    setter?.call(this.document, cookie);
  }

  _getPairs(): { [key: string]: string | null } {
    if (this.req === null) {
      const parsed = this.document.cookie.split('; ') ;
      // Object.create(null) has no prototype chain, so an attacker-controlled
      // cookie name of "__proto__"/"constructor"/"prototype" can't pollute
      // Object.prototype via the assignment below.
      const cookies: { [key: string]: string | null } = Object.create(null);
      +
      parsed.forEach((element: string) => {
        if (element) {
          let index = element.indexOf("=")
          let mainTokenValue = element.slice(index+1);
          const pair = element.split('=',1);
          pair.push(mainTokenValue);
          if (pair[0] === '__proto__' || pair[0] === 'constructor' || pair[0] === 'prototype') {
            return;
          }
          cookies[pair[0]] = typeof pair[1] !== 'undefined' || undefined ? pair[1] : null;
        }
      });
      return cookies;
    } else {
      const parsed = this.cookies.split('; ') ;
      const cookies: { [key: string]: string | null } = Object.create(null);
      +
      parsed.forEach((element: string) => {
        if (element) {
          let index = element.indexOf("=")
          let mainTokenValue = element.slice(index+1);
          const pair = element.split('=',1);
          pair.push(mainTokenValue);
          if (pair[0] === '__proto__' || pair[0] === 'constructor' || pair[0] === 'prototype') {
            return;
          }
          cookies[pair[0]] = typeof pair[1] !== 'undefined' || undefined ? pair[1] : null;
        }
      });
      return cookies;
    }
  }
}
